// extracted by mini-css-extract-plugin
export var createdDate = "_j7-1";
export var divider = "_j7-2";
export var headerDivider = "_j7-3";
export var messagesCard = "_j7-0";
export var messagesContainer = "_j7-6";
export var messagesContainerWrapper = "_j7-4";
export var showLeftPanelButton = "_j7-8";
export var topButtons = "_j7-7";
export var withPadding = "_j7-5";